import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'replaceCommaToDot',
  standalone: false,
})
export class ReplacePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return ''
    return value.replace(new RegExp(',', 'g'), '.')
  }
}
